.button {
  --btn-tertiary-background-color: var(--colors-grays-white);
  --btn-tertiary-border-color: var(--colors-grays-light);
}
